import { AlertVariantType } from '@src/constants/AlertVariantType';
import { AlertState, useAlertStore } from '@src/store/common/AlertStore';

const AlertService = () => {
  const AlertModel: AlertState = {
    title: null,
    variant: AlertVariantType.ERROR,
    visible: false,
    message: null,
    isPermanent: null,
    link: undefined,
  };

  const showAlert = useAlertStore((state) => state.showAlert);

  const HideAlert = async () => {
    await showAlert({
      title: null,
      variant: AlertVariantType.ERROR,
      visible: false,
      message: null,
    });
  };
  const ShowAlert = async (model: AlertState) => {
    await showAlert(structuredClone(model));
    if (
      model.visible === true &&
      (model.isPermanent === null || model.isPermanent === false)
    ) {
      setTimeout(async () => {
        await HideAlert();
      }, 3000);
    }
  };

  return { AlertModel, ShowAlert, HideAlert };
};

export { AlertService };
